import {
  _convertPropertyValuesToArray,
  AbstractEntity,
  logComputeFunction,
  ParamsByNames,
  PlethoraLib,
  PropertyValuesDictionary,
  Transaction,
  UiData,
} from "plethora-lib"
import { AbstractUiEntity } from "../UiClasses/AbstractUiEntity"
import { DataTypeShapeType, DataTypeDirection, DataTypeSize, DataTypeColor } from "./GeneratedDataTypes"

export interface IClickablePropertiesValues {}

export abstract class GeneratedClickable extends AbstractUiEntity {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super("Clickable", id, propertyValues, [], uiData)
  }

  public computeFunction(propertyName: string, functionParameters: ParamsByNames, uiData: UiData): number {
    let result: number
    switch (propertyName) {
      default:
        throw new Error("Error on computeFunction(), unknown computed property name " + propertyName)
    }
    if (typeof result !== "number") {
      throw new Error("Error on computeFunction(), result is not a number")
    }
    logComputeFunction(this.id, this.name, propertyName, functionParameters, uiData, result)
    return result
  }

  protected onPropertyUpdate(propertyName: string, newValue: any, oldValue: any, uiData: UiData): void {
    super.onPropertyUpdate(propertyName, newValue, oldValue, uiData)
    switch (propertyName) {
      default:
        throw new Error("Unkown property " + propertyName)
    }
  }

  protected onAction(actionName: string, actionParameters: ParamsByNames, uiData: UiData): void {
    super.onAction(actionName, actionParameters, uiData)
    switch (actionName) {
      case "Click": {
        this.onClick(uiData)
        return
      }

      default:
        throw new Error("Unkown action " + actionName)
    }
  }

  public applyClick(uiData: UiData = null): void {
    this.applyAction("Click", {}, uiData, true, null)
  }
  public transactionApplyClick(transaction: Transaction, uiData: UiData = null): void {
    this.applyAction("Click", {}, uiData, true, transaction)
  }
  protected abstract onClick(uiData: UiData): void

  protected onInteraction(
    interactionName: string,
    reactorEntity: AbstractEntity,
    interactionParameters: ParamsByNames,
    uiData: UiData
  ): void {
    super.onInteraction(interactionName, reactorEntity, interactionParameters, uiData)
    switch (interactionName) {
      default:
        throw new Error("Unkown interaction " + interactionName)
    }
  }

  public static createRequest(
    propertyValues: Partial<IClickablePropertiesValues>,
    quantity: number,
    uiData: UiData = null
  ): void {
    PlethoraLib.getInstance()
      .getMessagesManager()
      .sendCreateRequestMessage(
        {
          entityName: "Clickable",
          properties: _convertPropertyValuesToArray(propertyValues),
          quantity,
        },
        uiData
      )
  }
}
